var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c("h3", { staticStyle: { margin: "1rem", "font-size": "1.4rem" } }, [
        _vm._v("油品日报表")
      ]),
      _c(
        "div",
        { staticClass: "block" },
        [
          _c("span", { staticClass: "demonstration" }, [_vm._v("选择日期")]),
          _c("el-date-picker", {
            staticStyle: { width: "20rem !important" },
            attrs: {
              editable: false,
              size: "small",
              type: "daterange",
              "range-separator": "~",
              "start-placeholder": "开始日期",
              "end-placeholder": "结束日期",
              "value-format": "timestamp",
              "picker-options": _vm.pickerOptionsLimit
            },
            model: {
              value: _vm.datePickerValue,
              callback: function($$v) {
                _vm.datePickerValue = $$v
              },
              expression: "datePickerValue"
            }
          }),
          _c(
            "el-select",
            {
              attrs: {
                "value-key": "statTag",
                size: "small",
                placeholder: "请选择站点"
              },
              model: {
                value: _vm.selectedStation,
                callback: function($$v) {
                  _vm.selectedStation = $$v
                },
                expression: "selectedStation"
              }
            },
            [
              _c("el-option", {
                attrs: { label: "请选择站点", value: 0, disabled: "" }
              }),
              _vm._l(_vm.asyncStations, function(item) {
                return _c("el-option", {
                  key: item.ID,
                  attrs: { label: item.statTag, value: item }
                })
              })
            ],
            2
          ),
          _c(
            "el-button",
            {
              attrs: {
                loading: _vm.downloadLoading,
                size: "small",
                type: "primary"
              },
              on: { click: _vm.loadData }
            },
            [_vm._v("查询")]
          ),
          _c(
            "el-button",
            {
              attrs: {
                loading: _vm.downloadLoading,
                size: "small",
                type: "warning",
                icon: "el-icon-document"
              },
              on: {
                click: function($event) {
                  return _vm.exportExcel(_vm.excelSheets, "油品日报表")
                }
              }
            },
            [_vm._v(" 下载报表 ")]
          )
        ],
        1
      ),
      _c("br"),
      _c(
        "el-table",
        {
          ref: "stationDailyReportData",
          staticStyle: { width: "100%" },
          attrs: {
            id: "stationDailyReportData",
            data: _vm.stationDailyReportData,
            "summary-method": _vm.getSummaries,
            "show-summary": "",
            "sum-text": "合计",
            "highlight-current-row": "",
            border: "",
            height: "440"
          }
        },
        [
          _c("el-table-column", {
            attrs: {
              fixed: "",
              label: "日期",
              width: "100px",
              align: "center",
              prop: "reportDate"
            }
          }),
          _c(
            "el-table-column",
            {
              attrs: {
                label:
                  (_vm.sheetUnLoadCount ? "" : _vm.selectedStation.statTag) +
                  "当期销售情况",
                "header-align": "center"
              }
            },
            [
              _c(
                "el-table-column",
                { attrs: { label: "站点销售", "header-align": "center" } },
                [
                  _c(
                    "el-table-column",
                    { attrs: { label: "0# 柴油", align: "center" } },
                    [
                      _c("el-table-column", {
                        attrs: {
                          label: "升数",
                          width: "100px",
                          align: "center",
                          prop: "diesel0Nums"
                        }
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "金额",
                          width: "100px",
                          align: "center",
                          prop: "diesel0Amount"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-table-column",
                    { attrs: { label: "92# 汽油", align: "center" } },
                    [
                      _c("el-table-column", {
                        attrs: {
                          label: "升数",
                          width: "100px",
                          align: "center",
                          prop: "petrol92Nums"
                        }
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "金额",
                          width: "100px",
                          align: "center",
                          prop: "petrol92Amount"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-table-column",
                    { attrs: { label: "95# 汽油", align: "center" } },
                    [
                      _c("el-table-column", {
                        attrs: {
                          label: "升数",
                          width: "100px",
                          align: "center",
                          prop: "petrol95Nums"
                        }
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "金额",
                          width: "100px",
                          align: "center",
                          prop: "petrol95Amount"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-table-column",
                    { attrs: { label: "油机应收", align: "center" } },
                    [
                      _c("el-table-column", {
                        attrs: {
                          label: "升数",
                          width: "100px",
                          align: "center",
                          prop: "oilNums"
                        }
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "金额",
                          width: "100px",
                          align: "center",
                          prop: "oilAmount"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-table-column",
                    { attrs: { label: "回罐", align: "center" } },
                    [
                      _c("el-table-column", {
                        attrs: {
                          label: "升数",
                          width: "100px",
                          align: "center",
                          prop: "oilReturnNums"
                        }
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "金额",
                          width: "100px",
                          align: "center",
                          prop: "oilReturnAmount"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-table-column",
                    { attrs: { label: "油机异常", align: "center" } },
                    [
                      _c("el-table-column", {
                        attrs: {
                          label: "升数",
                          width: "100px",
                          align: "center",
                          prop: "oilWarnNums"
                        }
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "金额",
                          width: "100px",
                          align: "center",
                          prop: "oilWarnAmount"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-table-column",
                    { attrs: { label: "油机实收", align: "center" } },
                    [
                      _c("el-table-column", {
                        attrs: {
                          label: "升数",
                          width: "100px",
                          align: "center",
                          prop: "oilSaleNums"
                        }
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "金额",
                          width: "100px",
                          align: "center",
                          prop: "oilSaleAmount"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-table",
        {
          ref: "stationMonthTotalData",
          staticStyle: { width: "100%" },
          attrs: {
            id: "stationMonthTotalData",
            data: _vm.stationMonthTotalData,
            "highlight-current-row": "",
            border: "",
            height: "680"
          }
        },
        [
          _c("el-table-column", {
            attrs: {
              label: "数据项",
              width: "120px",
              prop: "title",
              align: "center"
            }
          }),
          _c(
            "el-table-column",
            { attrs: { "header-align": "center", label: "0#柴油" } },
            [
              _c("el-table-column", {
                attrs: {
                  label: "升数",
                  prop: "nums0",
                  width: "120px",
                  align: "center"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  label: "油机金额",
                  prop: "total0",
                  width: "140px",
                  align: "center"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  label: "优惠金额",
                  prop: "discount0",
                  width: "140px",
                  align: "center"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  label: "实收金额",
                  prop: "amount0",
                  width: "140px",
                  align: "center"
                }
              })
            ],
            1
          ),
          _c(
            "el-table-column",
            { attrs: { "header-align": "center", label: "92#汽油" } },
            [
              _c("el-table-column", {
                attrs: {
                  label: "升数",
                  prop: "nums92",
                  width: "120px",
                  align: "center"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  label: "油机金额",
                  prop: "total92",
                  width: "140px",
                  align: "center"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  label: "优惠金额",
                  prop: "discount92",
                  width: "140px",
                  align: "center"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  label: "实收金额",
                  prop: "amount92",
                  width: "140px",
                  align: "center"
                }
              })
            ],
            1
          ),
          _c(
            "el-table-column",
            { attrs: { "header-align": "center", label: "95#汽油" } },
            [
              _c("el-table-column", {
                attrs: {
                  label: "升数",
                  prop: "nums95",
                  width: "120px",
                  align: "center"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  label: "油机金额",
                  prop: "total95",
                  width: "140px",
                  align: "center"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  label: "优惠金额",
                  prop: "discount95",
                  width: "140px",
                  align: "center"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  label: "实收金额",
                  prop: "amount95",
                  width: "140px",
                  align: "center"
                }
              })
            ],
            1
          ),
          _c(
            "el-table-column",
            { attrs: { "header-align": "center", label: "合计" } },
            [
              _c("el-table-column", {
                attrs: {
                  label: "升数",
                  prop: "nums",
                  width: "120px",
                  align: "center"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  label: "油机金额",
                  prop: "total",
                  width: "140px",
                  align: "center"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  label: "优惠金额",
                  prop: "discount",
                  width: "140px",
                  align: "center"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  label: "实收金额",
                  prop: "amount",
                  width: "140px",
                  align: "center"
                }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }